import { VisitState } from '@/features/visits/api/types/visits';

export const getConfirmationStatus = ({
  hostConfirmed,
  deviceConfirmed,
  visitState,
}: {
  hostConfirmed: boolean | null | undefined;
  deviceConfirmed: boolean | null | undefined;
  visitState: string | undefined;
}) => {
  if (visitState === VisitState.REJECTED) {
    return 'visits:confirmation.rejected' as const;
  }

  if (hostConfirmed === null && deviceConfirmed === null) {
    return 'visits:confirmation.notRequired' as const;
  }

  if (hostConfirmed === undefined && deviceConfirmed === undefined) {
    return undefined;
  }

  return hostConfirmed || deviceConfirmed
    ? ('visits:confirmation.confirmed' as const)
    : ('visits:confirmation.awaitingForConfirmation' as const);
};
